import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, Input } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
	selector: 'app-signature-pad',
	templateUrl: './signature-pad.component.html',
	styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit {
	@Input() isSignatureMissingError: boolean;
	isMobileView: boolean;
	isSigned: boolean;
	signaturePad!: SignaturePad;
	@ViewChild('canvas') canvasEl!: ElementRef;
	signatureImg!: string;
	isSubmitDisabled: boolean;
	@Output() signature: EventEmitter<string>;

	@HostListener('window:resize') onResize() {
		this.updateIsMobileView();
	}

	updateIsMobileView(): void {
		if (window.innerWidth < 800) {
			this.isMobileView = true;
		} else {
			this.isMobileView = false;
		}
	}
	
	constructor() {
		this.updateIsMobileView();
		this.isMobileView = false;
		this.isSignatureMissingError = false;
		this.isSigned = false;
		this.isSubmitDisabled = false;
		this.signature = new EventEmitter<string>();
	}

	ngOnInit(): void {
	}
	
	ngAfterViewInit() {
		this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
	}

	startDrawing(event: Event) {
		// works in device not in browser
	}

	moved(event: Event) {
		// works in device not in browser
	}

	clearPad() {
		this.signaturePad.clear();
		this.signaturePad.on();
		this.signature.emit("");
		this.isSignatureMissingError = true;
		this.isSubmitDisabled = false;
		this.isSigned = false;
	}

	savePad() {
		this.isSigned = !this.signaturePad?.isEmpty();
		const base64Data = this.signaturePad?.toDataURL();
		this.signatureImg = base64Data;

		if(this.isSigned) {
			this.signaturePad.off();
			this.signature.emit(base64Data);
			this.isSubmitDisabled = true
			this.isSignatureMissingError = false;
		} else {
			this.isSignatureMissingError = true;
		}
	}
}